<form [formGroup]="newGameNotificationSettingsForm" (change)="onFormChange()">
  <mat-form-field appearance="outline" class="full-width margin-top-large" subscriptSizing="dynamic">
    <mat-label>Draw Notifications Start Time</mat-label>
    <input formControlName="notificationsBeginMinutesBeforeDraw" data-testid="draw-notification-start-time-input"
           placeholder="enter time you would like to send notifications" matInput>
    <mat-hint>On draw day, the draw reminder email goes out to players who have not entered this draw yet, starting at the first hourly check after this time, so start and end must be at least an hour apart. It does not affect winner results or manual notifications. 24-hour time (14:00 = 2pm, 07:00 = 7am).</mat-hint>
    <mat-error data-testid="notifications-start-error"
               *ngIf="newGameNotificationSettingsForm.controls.notificationsBeginMinutesBeforeDraw.errors && (newGameNotificationSettingsForm.controls.notificationsBeginMinutesBeforeDraw.touched || newGameNotificationSettingsForm.controls.notificationsBeginMinutesBeforeDraw.dirty)">
      required
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width margin-top-large" subscriptSizing="dynamic">
    <mat-label>Draw Notifications End Time</mat-label>
    <input formControlName="notificationsEndMinutesBeforeDraw" data-testid="draw-notification-end-time-input"
           placeholder="enter time you would like to stop sending notifications" matInput>
    <mat-hint>Every reminder batch must be sent before this time, counting from the hourly check that starts sending. If they cannot all fit, no reminders go out for that draw and game admins are emailed about the settings. 24-hour time (14:00 = 2pm, 07:00 = 7am).</mat-hint>
    <mat-error data-testid="notifications-end-error"
               *ngIf="newGameNotificationSettingsForm.controls.notificationsEndMinutesBeforeDraw.errors && (newGameNotificationSettingsForm.controls.notificationsEndMinutesBeforeDraw.touched || newGameNotificationSettingsForm.controls.notificationsEndMinutesBeforeDraw.dirty)">
      required
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width margin-top-large" subscriptSizing="dynamic">
    <mat-label>Notification Frequency (seconds)</mat-label>
    <input type="number"
           formControlName="notificationFrequency"
           data-testid="notification-frequency-input"
           placeholder="enter notification frequency in seconds"
           matInput>
    <mat-hint>Seconds between one batch of draw reminder emails and the next. 3600 = 1 hour, 1800 = 30 minutes.</mat-hint>
    <mat-error data-testid="notification-frequency-error"
               *ngIf="newGameNotificationSettingsForm.controls.notificationFrequency.errors && (newGameNotificationSettingsForm.controls.notificationFrequency.touched || newGameNotificationSettingsForm.controls.notificationFrequency.dirty)">
      required
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width margin-top-large" subscriptSizing="dynamic">
    <mat-label>Notification Chunk Size</mat-label>
    <input type="number"
           formControlName="notificationChunkSize"
           data-testid="notification-chunk-size-input"
           placeholder="enter chunk size for notification batches"
           matInput>
    <mat-hint>How many players get the draw reminder in each batch. For example, 1,000 players at 100 per batch, one batch an hour, needs 10 hours before the end time, counted from the hourly check that starts sending.</mat-hint>
    <mat-error data-testid="notification-chunk-size-error"
               *ngIf="newGameNotificationSettingsForm.controls.notificationChunkSize.errors && (newGameNotificationSettingsForm.controls.notificationChunkSize.touched || newGameNotificationSettingsForm.controls.notificationChunkSize.dirty)">
      required
    </mat-error>
  </mat-form-field>

  <mat-checkbox class="margin-top-large" formControlName="sendLastFourDigits">Send Last Four Digits of Winning Credit Card Number to Organization</mat-checkbox>
</form>
